var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoEducation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.5181 18.4203C49.9255 13.7499 59.5879 11.0653 69.8719 11V32.1744C68.9712 32.3319 68.1822 32.8141 67.6299 33.4959L41.5181 18.4203Z",
    fill: "#86D5D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M100.852 19.4946C109.293 24.5923 116.36 31.7361 121.366 40.2388L103.279 50.6818C102.676 49.9858 101.819 49.5163 100.852 49.4179L100.852 19.4946Z",
    fill: "#A2DADB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M73.9829 37.1629L97.5762 50.7845C98.1289 50.0981 98.9208 49.6124 99.8253 49.4542L99.8253 19.271L73.8777 34.2519C74.1032 34.731 74.2292 35.2661 74.2292 35.8306C74.2292 36.3001 74.142 36.7493 73.9829 37.1629Z",
    fill: "#86D5D9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M70.8989 11.002C81.1403 11.1104 90.7589 13.8165 99.1269 18.4928L73.3185 33.3933C72.7161 32.702 71.8619 32.2358 70.8989 32.1379V11.002Z",
    fill: "#86D5D9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M67.1036 34.373L40.9465 19.2713L40.9465 49.4181C41.9135 49.5164 42.7708 49.986 43.3735 50.682L67.0068 37.0373C66.8769 36.6591 66.8064 36.2532 66.8064 35.8308C66.8064 35.3134 66.9123 34.8206 67.1036 34.373Z",
    fill: "#57C4CB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9236 19.341C31.4054 24.4266 24.2705 31.5888 19.2178 40.1287L37.6745 50.7847C38.2272 50.0983 39.0191 49.6126 39.9236 49.4545L39.9236 19.341Z",
    fill: "#57C4CB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7019 41.0145C13.9327 49.4029 11.1518 59.0691 11 69.3722L37.0575 54.3279C36.9252 53.9466 36.8533 53.5371 36.8533 53.1108C36.8533 52.5973 36.9576 52.1081 37.1462 51.6633L18.7019 41.0145Z",
    fill: "#57C4CB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9208 84.0144V56.7672C38.9322 56.5943 38.0782 56.0303 37.524 55.2406L11.5048 70.2628L37.6577 85.3622C38.2109 84.6665 39.0086 84.174 39.9208 84.0144Z",
    fill: "#57C4CB"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M11 71.1534C11.1518 81.4564 13.9327 91.1227 18.7019 99.5111L37.0649 88.9092C36.9279 88.5219 36.8533 88.105 36.8533 87.6708C36.8533 87.1652 36.9544 86.6831 37.1375 86.2439L11 71.1534Z",
    fill: "#3299A0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2178 100.397C24.2705 108.937 31.4054 116.099 39.9236 121.184L39.9236 91.3269C38.9427 91.1554 38.0942 90.5987 37.5397 89.8185L19.2178 100.397Z",
    fill: "#3299A0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M69.8719 129.526C59.588 129.46 49.9255 126.776 41.5181 122.105L67.4945 107.108C68.0491 107.883 68.8948 108.436 69.8719 108.607V129.526Z",
    fill: "#3299A0"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M67.0863 103.534L43.5154 89.9255C42.9094 90.7168 41.9921 91.2571 40.9465 91.3635L40.9465 121.254L67.0217 106.2C66.8823 105.809 66.8064 105.389 66.8064 104.951C66.8064 104.449 66.9059 103.971 67.0863 103.534Z",
    fill: "#3299A0"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M99.127 122.033C90.7589 126.709 81.1403 129.415 70.8989 129.523V108.643C71.9406 108.537 72.8549 108.001 73.4609 107.214L99.127 122.033Z",
    fill: "#037C84"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M97.4429 89.8187L73.8979 103.412C74.1116 103.881 74.2307 104.402 74.2307 104.951C74.2307 105.436 74.1375 105.9 73.9681 106.325L99.8268 121.254V91.3271C98.8459 91.1556 97.9974 90.5989 97.4429 89.8187Z",
    fill: "#037C84"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M121.366 100.287C116.36 108.789 109.293 115.933 100.852 121.031V91.3635C101.897 91.2571 102.814 90.7168 103.42 89.9255L121.366 100.287Z",
    fill: "#037C84"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M129.514 71.3024C129.339 81.504 126.586 91.0776 121.878 99.3996L103.925 89.0342C104.091 88.6121 104.183 88.152 104.183 87.6706C104.183 87.1179 104.062 86.5935 103.846 86.1222L129.514 71.3024Z",
    fill: "#037C84"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M100.852 70.2628V83.978C101.826 84.0772 102.69 84.5536 103.293 85.259L129.268 70.2628L100.852 70.2628Z",
    fill: "#037C84"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M71.4097 70.2629L97.5626 85.3623C98.1158 84.6666 98.9135 84.1741 99.8257 84.0146V70.2629L71.4097 70.2629Z",
    fill: "#037C84"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7140_137184)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.56 79.5351C115.567 83.422 114.051 86.9531 111.576 89.5673C109.055 92.2336 107.618 95.7436 107.618 99.4125L101 101.547L94.3822 99.4125C94.3822 95.7633 92.9816 92.2504 90.4616 89.6081C87.9697 86.9953 86.4397 83.4572 86.4397 79.5604C86.4397 71.5195 92.9577 65.0015 101 65.0001C108.943 64.9669 115.567 71.562 115.56 79.5351Z",
    fill: "#FFEB78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.56 79.5351C115.567 83.422 114.051 86.9531 111.576 89.5673C109.055 92.2336 107.618 95.7436 107.618 99.4125L101 101.547V65.0001C108.943 64.9669 115.567 71.562 115.56 79.5351Z",
    fill: "#FFC43F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.759 77.4262H128V81.6449H121.759V77.4262Z",
    fill: "#FFC43F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.203 70.4292L124.851 67.0176L127.032 70.6289L121.384 74.0404L119.203 70.4292Z",
    fill: "#FFC43F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.21 88.6399L121.391 85.0287L127.039 88.4403L124.858 92.0515L119.21 88.6399Z",
    fill: "#FFC43F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74 77.4262H80.2411V81.6449H74V77.4262Z",
    fill: "#FFEB78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.9663 70.6364L77.1474 67.0251L82.796 70.4367L80.6149 74.048L74.9663 70.6364Z",
    fill: "#FFEB78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.9671 88.433L80.6157 85.0214L82.7968 88.6327L77.1482 92.0443L74.9671 88.433Z",
    fill: "#FFEB78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.993 77.4257V81.6445C104.852 81.6445 103.109 83.3868 103.109 85.53V101.547H98.8906V85.53C98.8906 83.3868 97.1482 81.6445 95.0065 81.6445V77.4257C97.3789 77.4257 99.5164 78.4509 101 80.0821C102.484 78.4509 104.621 77.4257 106.993 77.4257Z",
    fill: "#FFC43F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.993 77.4257V81.6445C104.852 81.6445 103.109 83.3868 103.109 85.53V101.547H101V80.0821C102.484 78.4509 104.621 77.4257 106.993 77.4257Z",
    fill: "#FFA742"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.618 99.4124V106.16L104.971 108.806H97.0287L94.3821 106.16V99.4124H107.618Z",
    fill: "#575676"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.618 99.4124V106.16L104.971 108.806H101V99.4124H107.618Z",
    fill: "#3D3C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.5 114.5V123.5L101 134.705L100.982 134.712L69.5 123.5V114.5H92C96.9711 114.5 101 118.529 101 123.5C101 118.529 105.029 114.5 110 114.5H132.5Z",
    fill: "#E6EEF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.5 114.5V123.5L101 134.705V123.5C101 118.529 105.029 114.5 110 114.5H132.5Z",
    fill: "#BAC4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137 123.5V132.5H114.5C112.101 132.488 110.021 134.471 110 137H91.9999C91.9999 134.515 89.9848 132.5 87.5 132.5H65V123.5H91.9999C96.971 123.5 101 127.529 101 132.5C101 127.529 105.029 123.5 110 123.5H137Z",
    fill: "#7696DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137 123.5V132.5H114.5C112.101 132.488 110.021 134.471 110 137H101V132.5C101 127.529 105.029 123.5 110 123.5H137Z",
    fill: "#576FA6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7140_137184"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    fill: "white",
    transform: "translate(65 65)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoEducation);
export default __webpack_public_path__ + "static/media/Logo_education.b11877ca3381727dda89b12a5c053bc1.svg";
export { ForwardRef as ReactComponent };